module.exports = __webpack_public_path__ + "media/images/emblems/Lostallo_wappen-c0be695ec6a699f4a75c9f56bf55db0a.svg";